import { sanitizeInput } from "../common/security-utils";
import workflowTick from "../../assets/svg/workflow-tick.svg";

const WorkflowTab = ({
    isWorkflowLoading,
    estimateWorkflow,
    actualWorkflow,
    setSelectedStop,
    getSkippedMilestoneDetails,
    setAttachmentUrls,
    setShowAttachmentModal,
}) => {
    /** Skeleton placeholder for a workflow column */
    const WorkflowSkeleton = () => (
        <div className="col-12 col-lg-4">
            <div className="mx-4 mb-3 mt-2 d-flex align-items-center justify-content-center rounded-3 px-2 py-2">
                <div className="skeleton skeleton-text" style={{ width: "150px", height: "14px" }} />
            </div>
            {Array.from({ length: 3 }).map((_, idx) => (
                <div key={idx} className="w-100 d-flex justify-content-start mb-3">
                    <div className="d-flex flex-column align-items-center">
                        <div className="skeleton" style={{ width: "24px", height: "24px", borderRadius: "50%" }} />
                        {idx !== 2 && <div style={{ borderLeft: "2px dotted #ddd", height: "60px" }}></div>}
                    </div>
                    <div className="ms-3 flex-grow-1">
                        <div className="skeleton skeleton-text" style={{ width: "120px", height: "16px", marginBottom: "8px" }} />
                        <div className="skeleton skeleton-text-sm" style={{ width: "180px", marginBottom: "4px" }} />
                        <div className="skeleton skeleton-text-sm" style={{ width: "100px" }} />
                    </div>
                </div>
            ))}
        </div>
    );

    return (
        <div className="w-100 m-2 bg-white rounded-4 p-3">
            <div className="row">
                <div className="col-12 ">
                    <div className="row">
                        <div className="col-xl-12 d-flex justify-content-start">
                            <p className="fs-18 fw-600 mb-0">Workflow details </p>
                        </div>
                    </div>
                    <div className="row">
                        {isWorkflowLoading ? (
                            <>
                                <WorkflowSkeleton />
                                <div className="d-none d-lg-block" style={{ borderLeft: "2px solid #EBEBEB", height: "auto", width: "auto" }}></div>
                                <WorkflowSkeleton />
                            </>
                        ) : (
                            <>
                                {/* Estimated Workflow */}
                                <div className="col-12 col-lg-4">
                                    <div>
                                        <div className="mx-4 mb-3 mt-2 d-flex align-items-center justify-content-center rounded-3 px-2 py-2 fs-13 fw-600" style={{ background: "#F8F8F8", color: "#5F5E5B" }}>
                                            ESTIMATED WORKFLOW
                                        </div>
                                        {estimateWorkflow.map((row, index) => (
                                            <div key={row.id || index} className="w-100 d-flex justify-content-start ">
                                                <div className="d-flex flex-column align-items-center" style={{ height: "auto" }}>
                                                    <img src={workflowTick} alt="tick" />
                                                    {index !== estimateWorkflow.length - 1 && (
                                                        <div style={{ borderLeft: "2px dotted #aaa", height: "100%" }}></div>
                                                    )}
                                                </div>

                                                <div className="mt-0 ms-3 mb-3">
                                                    <div className="d-flex align-items-center justify-content-start">
                                                        <span className="fs-14 fw-700 " style={{ color: "#2C8C53" }}>
                                                            {sanitizeInput(row.status ?? "")}
                                                        </span>
                                                    </div>
                                                    <div className="mt-1 fs-12 fw-400 cardTextGrey d-flex justify-content-start">{sanitizeInput(row.to_char ?? "")}</div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Divider */}
                                <div
                                    className="d-none d-lg-block mt-5"
                                    style={{
                                        borderLeft: "2px solid #EBEBEB",
                                        height: "auto",
                                        width: "auto",
                                    }}
                                ></div>

                                {/* Actual Workflow */}
                                <div className="col-12 col-lg-4">
                                    <div>
                                        <div className="mx-4 mb-3 mt-2 d-flex align-items-center justify-content-center rounded-3 px-2 py-2 fs-13 fw-600" style={{ background: "#F8F8F8", color: "#5F5E5B" }}>
                                            ACTUAL WORKFLOW
                                        </div>
                                        {actualWorkflow.map((row, index) => (
                                            <div key={row.id || index} className="w-100 d-flex justify-content-start ">
                                                <div className="d-flex flex-column align-items-center" style={{ height: "auto" }}>
                                                    <img src={workflowTick} alt="tick" />
                                                    {index !== actualWorkflow.length - 1 && (
                                                        <div style={{ borderLeft: "2px dotted #aaa", height: "100%" }}></div>
                                                    )}
                                                </div>

                                                <div className="mt-0 ms-3 mb-3">
                                                    <div className="d-flex align-items-center justify-content-start">
                                                        <span className="fs-14 fw-700 " style={{ color: "#2C8C53" }}>
                                                            {sanitizeInput(row.status ?? "")}
                                                        </span>
                                                        <div
                                                            className="mx-2"
                                                            style={{
                                                                width: "5px",
                                                                height: "5px",
                                                                borderRadius: "100px",
                                                                background: "#D9D9D9",
                                                            }}
                                                        ></div>
                                                    </div>

                                                    <div className="mt-2 fs-13 fw-400 textFontColor d-flex justify-content-start">{sanitizeInput(row.comments ?? "")}</div>
                                                    <div className="mt-1 fs-12 fw-400 cardTextGrey d-flex justify-content-start">{sanitizeInput(row.to_char ?? "")}</div>
                                                    <div className="mt-2 d-flex align-items-center justify-content-start">
                                                        {row.attachments_count > 0 && (
                                                            <div
                                                                className="d-flex align-items-center justify-content-center rounded-4 px-2 py-1 fs-11 fw-400"
                                                                style={{
                                                                    background: "#F8F8F8",
                                                                    color: "#5F5E5B",
                                                                    cursor: "pointer",
                                                                }}
                                                                onClick={() => {
                                                                    if (Array.isArray(row.attachments) && row.attachments.length > 0) {
                                                                        setAttachmentUrls(row.attachments);
                                                                        setShowAttachmentModal(true);
                                                                    } else if (typeof row.attachments === "string" && row.attachments !== "") {
                                                                        setAttachmentUrls([row.attachments]);
                                                                        setShowAttachmentModal(true);
                                                                    }
                                                                }}
                                                            >
                                                                View attachments ({sanitizeInput(String(row.attachments_count ?? "0"))})
                                                            </div>
                                                        )}

                                                        {row.status === "skipped" && (
                                                            <div
                                                                onClick={() => {
                                                                    setSelectedStop(row.stop_id);
                                                                    getSkippedMilestoneDetails(row.trip_id, row.stop_id);
                                                                }}
                                                                className="cursor-pointer ms-2 d-flex align-items-center justify-content-center rounded-4 px-2 py-1 fs-11 fw-400"
                                                                style={{
                                                                    background: "#F8F8F8",
                                                                    color: "#5F5E5B",
                                                                }}
                                                            >
                                                                Update
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div >
    );
};

export default WorkflowTab;
